/**
 * Navigatie, richting en structuur.
 *
 * Gegenereerd bij de Hugeicons-migratie; handmatig uitbreiden mag.
 * Voeg een icoon hier toe, nooit rechtstreeks `@hugeicons/*` in een component.
 */
import {
    ArrowDown01Icon,
    ArrowLeft01Icon,
    ArrowLeft02Icon,
    ArrowLeftDoubleIcon,
    ArrowLeftRightIcon,
    ArrowRight01Icon,
    ArrowRight02Icon,
    ArrowRightDoubleIcon,
    ArrowUp01Icon,
    ArrowUpRight01Icon,
    ChevronDownIcon,
    ChevronLeftIcon,
    ChevronRightIcon,
    ChevronUpIcon,
    CircleArrowUp01Icon,
    CodeIcon,
    CommandIcon,
    CommandLineIcon,
    GitBranchIcon,
    HashIcon,
    Home01Icon,
    Layers01Icon,
    Link01Icon,
    LinkSquare01Icon,
    Menu01Icon,
    MoreHorizontalIcon,
    MoreVerticalIcon,
    UnfoldMoreIcon,
} from "@hugeicons/core-free-icons";

import { createIcon } from "./create-icon";

export const ArrowDown = createIcon(ArrowDown01Icon, "ArrowDown");
export const ArrowLeft = createIcon(ArrowLeft01Icon, "ArrowLeft");
export const ArrowLeftRight = createIcon(ArrowLeftRightIcon, "ArrowLeftRight");
export const ArrowNarrowLeft = createIcon(ArrowLeft02Icon, "ArrowNarrowLeft");
export const ArrowNarrowRight = createIcon(ArrowRight02Icon, "ArrowNarrowRight");
export const ArrowRight = createIcon(ArrowRight01Icon, "ArrowRight");
export const ArrowUp = createIcon(ArrowUp01Icon, "ArrowUp");
export const ArrowUpCircle = createIcon(CircleArrowUp01Icon, "ArrowUpCircle");
export const ArrowUpRight = createIcon(ArrowUpRight01Icon, "ArrowUpRight");
export const ChevronDown = createIcon(ChevronDownIcon, "ChevronDown");
export const ChevronLeft = createIcon(ChevronLeftIcon, "ChevronLeft");
export const ChevronLeftDouble = createIcon(ArrowLeftDoubleIcon, "ChevronLeftDouble");
export const ChevronRight = createIcon(ChevronRightIcon, "ChevronRight");
export const ChevronRightDouble = createIcon(ArrowRightDoubleIcon, "ChevronRightDouble");
export const ChevronSelectorVertical = createIcon(UnfoldMoreIcon, "ChevronSelectorVertical");
export const ChevronUp = createIcon(ChevronUpIcon, "ChevronUp");
export const Code02 = createIcon(CodeIcon, "Code02");
export const Command = createIcon(CommandIcon, "Command");
export const DotsVertical = createIcon(MoreVerticalIcon, "DotsVertical");
export const ExternalLink = createIcon(LinkSquare01Icon, "ExternalLink");
export const GitBranch = createIcon(GitBranchIcon, "GitBranch");
export const Hash = createIcon(HashIcon, "Hash");
export const Home = createIcon(Home01Icon, "Home");
export const Layers = createIcon(Layers01Icon, "Layers");
export const Layers3 = createIcon(Layers01Icon, "Layers3");
export const LayersTwo01 = createIcon(Layers01Icon, "LayersTwo01");
export const Link2 = createIcon(Link01Icon, "Link2");
export const Menu01 = createIcon(Menu01Icon, "Menu01");
export const MoreHorizontal = createIcon(MoreHorizontalIcon, "MoreHorizontal");
export const TerminalSquare = createIcon(CommandLineIcon, "TerminalSquare");
